import * as ScrollMagic from 'scrollmagic';
import {TweenMax, TimelineMax, TweenLite, Linear} from 'gsap/all';
import {ScrollMagicPluginGsap} from 'scrollmagic-plugin-gsap';
import AOS from 'aos';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

AOS.init({
	offset: 200,
	duration: 500,
	easing: 'ease-in-out',
	once: true,
	disable: () => {
		let maxWidth = 1025;

		return window.innerWidth < maxWidth;
	},
});

function onElementHeightChange(elm, callback) {
	let lastHeight = elm.clientHeight;

	let newHeight;

	(function run() {
		newHeight = elm.clientHeight;
		if (lastHeight !== newHeight) {
			callback();
		}
		lastHeight = newHeight;

		if (elm.onElementHeightChangeTimer) {
			clearTimeout(elm.onElementHeightChangeTimer);
		}

		elm.onElementHeightChangeTimer = setTimeout(run, 200);
	})();
}

if (innerWidth > 1024) {
	onElementHeightChange(document.body, () => {
		AOS.refresh();
	});
}

let controller = new ScrollMagic.Controller();

const pageTimeline = new TimelineMax();

$(document).ready(() => {
	if ($('.main-page').length && innerWidth > 1024) {
		new TimelineMax()
			.to($('.top-block__title'), 0.6, {
				autoAlpha: 1,
				y: 0,
				clearProps: 'all',
				onComplete() {
					$('.top-block__title').removeClass('is-none-animate');
				},
			}, 0.8)
			.to($('.top-block__subtitle'), 0.6, {
				autoAlpha: 1,
				y: 0,
				clearProps: 'all',
				onComplete() {
					$('.top-block__subtitle').removeClass('is-none-animate');
				},
			}, 1.1)
			.to($('.top-block__text'), 0.6, {
				autoAlpha: 1,
				y: 0,
				clearProps: 'all',
				onComplete() {
					$('.top-block__text').removeClass('is-none-animate');
				},
			}, 1.4)
			.to($('.top-block__item-pagination'), 0.6, {
				autoAlpha: 1,
				y: 0,
				clearProps: 'all',
				onComplete() {
					$('.top-block__item-pagination').removeClass('is-none-animate');
				},
			}, 1.7);
	}
});

if ($('.main-page').length) {
	let investmentNumbers = new TimelineMax()
		.add(() => {
			$('.investment__value-number').each((index, element) => {
				let count = {val: 0};

				let newVal = $(element).attr('data-count');

				function updateHandler() {
					$(element).text(count.val);
				}

				TweenLite.to(count, 2, {
					val: newVal,
					roundProps: 'val',
					onUpdate: updateHandler,
				});
			});
		});

	new ScrollMagic.Scene({
		triggerElement: '.investment__info',
		triggerHook: 0.85,
		reverse: false,
	})
		.setTween(investmentNumbers)
		.addTo(controller);

	let diagramNumbers = new TimelineMax()
		.add(() => {
			$('.why__value-number-diagram').each((index, element) => {
				let count = {val: 0};

				let newVal = $(element).attr('data-count');

				function updateHandler() {
					$(element).text(count.val);
				}

				TweenLite.to(count, 2.5, {
					val: newVal,
					roundProps: 'val',
					onUpdate: updateHandler,
				});
			});
		});

	new ScrollMagic.Scene({
		triggerElement: '.why__diagram',
		triggerHook: 0.85,
		reverse: false,
	})
		.setTween(diagramNumbers)
		.addTo(controller);

	let joinNumbers = new TimelineMax()
		.add(() => {
			$('.join__count-number').each((index, element) => {
				let count = {val: 0};

				let newVal = $(element).attr('data-count');

				function updateHandler() {
					$(element).text(count.val);
				}

				TweenLite.to(count, 2, {
					val: newVal,
					roundProps: 'val',
					onUpdate: updateHandler,
				});
			});
		});

	new ScrollMagic.Scene({
		triggerElement: '.join__text',
		triggerHook: 0.85,
		reverse: false,
	})
		.setTween(joinNumbers)
		.addTo(controller);

	let diagramNumbersTeam = new TimelineMax()
		.add(() => {
			$('.team__count-number').each((index, element) => {
				let count = {val: 0};

				let newVal = $(element).attr('data-count');

				function updateHandler() {
					$(element).text(count.val);
				}

				TweenLite.to(count, 2, {
					val: newVal,
					roundProps: 'val',
					onUpdate: updateHandler,
				});
			});
		});

	new ScrollMagic.Scene({
		triggerElement: '.team__diagram',
		triggerHook: 0.85,
		reverse: false,
	})
		.setTween(diagramNumbersTeam)
		.addTo(controller);

	if (innerWidth > 1024) {
		pageTimeline.set($('.why__animate-block'), {
			y: '100%',
		});
		pageTimeline.set($('.why__title-diagram'), {
			autoAlpha: 0,
		});
		pageTimeline.set($('.join__item-list'), {
			autoAlpha: 0,
			y: 50,
		});
		pageTimeline.set($('.team__item-diagram'), {
			autoAlpha: 0,
			y: 50,
		});

		let investment = new TimelineMax()
			.from($('.investment__title-info img'), 0.5, {
				autoAlpha: 0,
				clearProps: 'all',
			})
			.from($('.investment__inner-title-line'), 0.75, {
				x: '-100%',
				clearProps: 'all',
				ease: Linear.easeNone,
			});

		new ScrollMagic.Scene({
			triggerElement: '.investment__info',
			triggerHook: 0.75,
			reverse: false,
		})
			.setTween(investment)
			.addTo(controller);

		let diagrams = new TimelineMax()
			.add(() => {
				$('.why__animate-block').each((index, element) => {
					new TimelineMax()
						.to(element, 2, {
							y: 0,
							clearProps: 'all',
							ease: Linear.easeNone,
						});
				});
			})
			.to($('.why__title-diagram'), 0.75, {
				autoAlpha: 1,
				clearProps: 'all',
			}, 2.25);

		new ScrollMagic.Scene({
			triggerElement: '.why__diagram',
			triggerHook: 0.85,
			reverse: false,
		})
			.setTween(diagrams)
			.addTo(controller);

		let joinList = new TimelineMax()
			.add(() => {
				const join = new TimelineMax();

				$('.join__item-list').each((index, element) => {
					const tl = new TimelineMax()
						.to(element, 0.5,
							{
								y: 0,
								autoAlpha: 1,
								clearProps: 'all',
							}, '+=0.05');

					join.add(tl, '-=0.2');
				});
			});

		new ScrollMagic.Scene({
			triggerElement: '.join__right',
			triggerHook: 0.75,
			reverse: false,
		})
			.setTween(joinList)
			.addTo(controller);

		let diagramBlocksTeam = new TimelineMax()
			.add(() => {
				const join = new TimelineMax();

				$('.team__item-diagram').each((index, element) => {
					const tl = new TimelineMax()
						.to(element, 0.75,
							{
								y: 0,
								autoAlpha: 1,
								clearProps: 'all',
							}, '+=0.05');

					join.add(tl, '-=0.2');
				});
			});

		new ScrollMagic.Scene({
			triggerElement: '.team__diagram',
			triggerHook: 0.75,
			reverse: false,
		})
			.setTween(diagramBlocksTeam)
			.addTo(controller);
	}
}

